import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { businessDateStr } from "@/lib/businessDate";
import { shiftDay } from "@/components/OperationsUI";

export default function OperationDate({ value, onChange }) {
  const today = businessDateStr(), yesterday = shiftDay(today, -1);
  return <div className="operation-date">
    <div className="operation-date-control"><button type="button" aria-label="Dia anterior" onClick={() => onChange(shiftDay(value, -1))}><ChevronLeft size={20} /></button>
      <label><span className="sr-only">Data do fechamento</span><input aria-label="Data do fechamento" className="op-input" type="date" value={value} max={today} onChange={e => e.target.value && onChange(e.target.value)} /></label>
      <button type="button" aria-label="Próximo dia" disabled={value >= today} onClick={() => onChange(shiftDay(value, 1))}><ChevronRight size={20} /></button></div>
    <div className="flex gap-2"><button type="button" className={value === yesterday ? "date-shortcut active" : "date-shortcut"} onClick={() => onChange(yesterday)}>Ontem</button><button type="button" className={value === today ? "date-shortcut active" : "date-shortcut"} onClick={() => onChange(today)}>Hoje</button></div>
  </div>;
}
